<template>
  <v-container fluid>
    <Breadcrumbs/>
    <v-row>
      <v-col md="10">
        <h1 class="mb-1">
          Акции
        </h1>
        <p class="mb-2">
          Сортируются на сайте по <b>убыванию</b> индекса сортировки
        </p>
      </v-col>
      <v-col md="2" class="text-right">
        <v-btn color="success" @click="create" large>
          <v-icon
            left
            v-text="`mdi-plus`"
          />
          Новая акция
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              outlined
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            fixed-header
            :search="search"
            :headers="headers"
            :items="promotions"
            :items-per-page="-1"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            class="elevation-1 menu-list"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <router-link
                    tag="a"
                    class="mr-2 v-btn v-btn--flat v-btn--icon v-btn--round theme--light elevation-1 v-size--small accent--text"
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'Акция', params: { id: item.id, isedit: true } }"
                  >
                    <span class="v-btn__content">
                      <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-pencil</v-icon>
                    </span>
                  </router-link>

                  <!--                  <v-btn
                    color="accent"
                    class="mr-4 mb-2 mt-2"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="goToItem(item.id)"
                  >
                    &lt;!&ndash; eslint-disable-next-line &ndash;&gt;
                    <v-icon
                      small
                      color="success"
                    >
                      mdi-pencil
                    </v-icon>
                  </v-btn>-->
                </template>
                <span>Редактировать</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    elevation="1"
                    icon
                    small
                    class="mb-2 mt-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDeleteModal(item.id)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Удалить</span>
              </v-tooltip>
            </template>

            <template v-slot:item.regions="{ item }">
              {{ getRegionsColumnString(item.regions) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Вы действительно хотите удалить акцию?
          </v-card-title>
          <v-card-text>
            Эту операцию невозможно будет отменить, вы точно хотите удалить акцию?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="closeModal">
              Отмена
            </v-btn>
            <v-btn color="red darken-1" text @click="deleteItem">
              Согласен
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    data () {
      return {
        search: '',
        deleteId: null,
        dialog: false,
        sortBy: 'sortOrder',
        sortDesc: true,
        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Регионы', value: 'regions', align: 'start' },
          { text: 'Сортировка', value: 'sortOrder', align: 'center' },
          { text: 'Действия', value: 'actions', align: 'end', sortable: false },
        ],
      }
    },
    computed: {
      ...mapState('promotions', ['promotions']),
    },
    created () {
      this.$store.dispatch('promotions/fetchPromotionsList', {
        limit: 100000,
        offset: 0,
        page: 0,
      })
    },
    methods: {
      getRegionsColumnString (regions) {
        if (_.isEmpty(regions)) {
          return ''
        }

        return regions.map((item) => item.name).join(', ')
      },
      openDeleteModal (id) {
        this.deleteId = id
        this.dialog = true
      },
      closeModal () {
        this.deleteId = null
        this.dialog = false
      },
      deleteItem () {
        this.$store.dispatch('promotions/removePromotions', this.deleteId).then(() => {
          this.$store.dispatch('promotions/fetchPromotionsList', {
            limit: 100000,
            offset: 0,
            page: 0,
          }).catch(err => err)
            .finally(() => {
              this.closeModal()
            })
        }).catch(err => err)
      },
      goToItem (id) {
        this.$router.push({ name: 'Акция', params: { id: id } })
      },
      create () {
        this.$router.push('/promotions/create')
      },
    },
  }
</script>

<style scoped></style>
